import { Checkbox } from '@mantine/core';
import React from 'react';

import { useFeatureFlags } from '@portals/api/partners';
import { isPartnerFeatureOn } from '@portals/framework';
import { FieldRendererProps } from '@portals/types';

export function CommandFeatures({
  setFieldValue,
  field,
  value,
}: FieldRendererProps) {
  const featureFlags = useFeatureFlags();

  const convertValueToOpenTunnelArray = (isChecked: boolean) => {
    if (isChecked) {
      setFieldValue?.(field.name, ['open_tunnel']);

      return;
    }

    setFieldValue?.(field.name, []);
  };

  if (!isPartnerFeatureOn(featureFlags, 'tunnel_poc')) return null;

  return (
    <Checkbox
      onChange={(event) => convertValueToOpenTunnelArray(event.target.checked)}
      label="Open tunnel"
      checked={value.includes('open_tunnel')}
    />
  );
}
